import styles from "./index.module.css";
import { useState } from "react";
import CardSlider from "../../../Components/CardSlider";
import Clampable from "../../../Components/CardSlider/Clampable";
import A1A2 from "./A1A2.json";
import A2B1 from "./A2B1.json";
import B1B2 from "./B1B2.json";
import B1plusB2 from "./B1plusB2.json";
import B2C1 from "./B2C1.json";
import C1C2 from "./C1C2.json";

const program = {
  A1A2,
  A2B1,
  B1B2,
  B1plusB2,
  B2C1,
  C1C2,
};

const levels = [
  { key: "A1A2", label: "A1-A2" },
  { key: "A2B1", label: "A2-B1" },
  { key: "B1B2", label: "B1-B2" },
  { key: "B1plusB2", label: "B1+B2" },
  { key: "B2C1", label: "B2-C1" },
  { key: "C1C2", label: "C1-C2" },
];

// "Grammar: verb be +" -> "grammar: verb be +", the way the labels read in the design.
const lowercaseLabel = (text) =>
  text.replace(/^[^:]+:/, (label) => label.toLowerCase());

function UnitCard({ unit, expanded = false, onShowMore }) {
  return (
    <article
      className={[styles.card, expanded && styles.expandedCard]
        .filter(Boolean)
        .join(" ")}
    >
      <h3 className={styles.unitTitle}>{unit.title.trim().toUpperCase()}</h3>

      <Clampable expanded={expanded} onShowMore={onShowMore}>
        <ol className={styles.lessons}>
          {unit.program.map((lesson, lessonIndex) => (
            <li key={lessonIndex} className={styles.lesson}>
              <p className={styles.lessonTitle}>{lesson.title}</p>
              {lesson.list.length > 0 && (
                <ul className={styles.lessonList}>
                  {lesson.list.map((item, itemIndex) => (
                    <li key={itemIndex}>{lowercaseLabel(item)}</li>
                  ))}
                </ul>
              )}
            </li>
          ))}
        </ol>
      </Clampable>
    </article>
  );
}

export default function Program() {
  const [active, setActive] = useState("A2B1");

  return (
    <section className={styles.section} id={"program"}>
      <div className={styles.container}>
        <CardSlider
          title="Програма"
          headClassName={styles.header}
          controls={
            <div className={styles.tags}>
              {levels.map((level) => (
                <button
                  key={level.key}
                  type="button"
                  onClick={() => setActive(level.key)}
                  className={active === level.key ? styles.active : ""}
                >
                  {level.label}
                </button>
              ))}
            </div>
          }
          items={program[active]}
          resetKey={active}
          renderCard={(unit, { onShowMore }) => (
            <UnitCard unit={unit} onShowMore={onShowMore} />
          )}
          renderExpanded={(unit) => <UnitCard unit={unit} expanded />}
        />
      </div>
    </section>
  );
}
